export const removeDuplicatesByAttribute = (array, attributeName) => {
  const attributeSet = new Set();

  const response = array.filter((obj) => {
    const attributeValue = obj[attributeName];

    if (!attributeSet.has(attributeValue)) {
      attributeSet.add(attributeValue);
      return true;
    }
    return false;
  });

  return response;
};
